export default "__VITE_ASSET__PJodMGQK__"